import React, { useState } from "react";
import afterSalahData from "./AfterSalahData";
import { Container } from "../../Container/Container";
import styled from "styled-components";
import Wird from "../../Wird/Wird";
import Navbar from "../../Navbar/Navbar";

const ContentBox = styled.div``;

const Title = styled.h2`
  margin-bottom: 20px;
  font-weight: normal;
  color: var(--sec-color);
`;

const Text = styled.p``;

const AwradBox = styled.div`
  margin: 40px 0;
`;

const Text2 = styled.p``;

function AfterSalah() {
  const [counter1, setCounter1] = useState(0);
  const [counter2, setCounter2] = useState(0);
  const [counter3, setCounter3] = useState(0);

  // Counts
  const Count1 = () => {
    setCounter1(counter1 + 1);
  };
  const Count2 = () => {
    setCounter2(counter2 + 1);
  };
  const Count3 = () => {
    setCounter3(counter3 + 1);
    counter3 > 100 && setCounter3(100);
  };

  // Resets
  const Reset1 = () => {
    setCounter1(0);
  };

  const Reset2 = () => {
    setCounter2(0);
  };
  const Reset3 = () => {
    setCounter3(0);
  };
  return (
    <>
      <Navbar brand={afterSalahData.brand} />
      <Container>
        <ContentBox>
          <Title>{afterSalahData.title}</Title>
          <Text>{afterSalahData.text}</Text>
          <AwradBox>
            <Wird
              title={afterSalahData.awradList[0].title}
              counter={counter1}
              count={Count1}
              reset={Reset1}
            />
            <Wird
              title={afterSalahData.awradList[1].title}
              counter={counter2}
              count={Count2}
              reset={Reset2}
            />
            <Wird
              title={afterSalahData.awradList[2].title}
              counter={counter3}
              count={Count3}
              reset={Reset3}
            />
          </AwradBox>
          <Text2>{afterSalahData.text2}</Text2>
        </ContentBox>
      </Container>
    </>
  );
}

export default AfterSalah;
